import Select from "react-select";
export function VariantColorSelector({
  variantColors,
  selectedVariantColors,
  setSelectedVariantColors,
  selectAllVariantColors,
}: {
  variantColors: any[];
  selectedVariantColors: any[];
  setSelectedVariantColors: (variantColors: any) => void;
  selectAllVariantColors: () => void;
}) {
  return (
    <div>
      <div className="flex flex-row justify-between items-center">
        <div className="flex-1 min-w-0 mt-4">
          <p>Select Variant Colors</p>
        </div>
        <button className="underline" onClick={() => selectAllVariantColors()}>
          <p className="underline px-4 pt-2">Select All Colors</p>
        </button>
      </div>
      <div className="mt-1 space-y-8">
        <Select
          isSearchable
          isMulti
          name="colors"
          options={variantColors}
          value={selectedVariantColors}
          className="basic-multi-select"
          classNamePrefix="select"
          onChange={(e) => setSelectedVariantColors(e)}
        />
      </div>
    </div>
  );
}
